// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import visitExpenseEntity from './entities/visit-expense.json';
import visitExpenseMenu from '../pages/visit-expense/menu.json';
import visitExpenseFullForm from '../pages/visit-expense/forms/full.json';
import visitExpenseContextForm from '../pages/visit-expense/forms/context.json';
import visitExpenseMiniForm from '../pages/visit-expense/forms/mini.json';
import visitExpenseLookupForm from '../pages/visit-expense/forms/lookup.json';
import visitExpenseTableView from '../pages/visit-expense/views/table.json';
import visitExpenseCardsView from '../pages/visit-expense/views/cards.json';
import visitExpenseDashboardView from '../pages/visit-expense/views/dashboard.json';

/** Тип запису «Витрата візиту» зі сторінками пакета: меню, форми та подання з pages/visit-expense/. */
export const visitExpenseDefinition: IRecordTypeDefinition = {
  ...visitExpenseEntity,
  views: assembleViewSet({
      table: visitExpenseTableView,
      cards: visitExpenseCardsView,
      dashboard: visitExpenseDashboardView,
  }),
  form: visitExpenseFullForm,
  forms: { full: visitExpenseFullForm, context: visitExpenseContextForm, mini: visitExpenseMiniForm, lookup: visitExpenseLookupForm },
  menu: visitExpenseMenu,
} as IRecordTypeDefinition;
